import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_TIME_FORMAT } from '../../constants/systemConstants';
import { PrintType, PrintTypeMode } from '../../types';
import { alertMessage } from '../../utils/alertMessage';
import { postDataWithAuthToken } from '../../utils/axiosRequest';
import GeneralPrintContent from '../GeneralPrintContent';
import getDashboardStyle from '../../utils/getDashboardStyle';

type OrderPrintModalProps = {
  mode: PrintTypeMode;
  printoutTableData: PrintType;
  onCancel: Function;
  isFullVersion?: boolean;
};

const OrderPrintModal = ({
  mode,
  printoutTableData,
  onCancel,
  isFullVersion = true,
}: OrderPrintModalProps) => {
  //General Components
  const { t } = useTranslation();
  const isSubscribed = useRef(true);
  const orderIds = printoutTableData.orderIds ?? [];
  const routeId = printoutTableData.routeId;
  const userId = printoutTableData.userId;
  const [modalLoading, setModalLoading] = useState(false);

  // Sets isSubscribed to false if component becomes unmounted
  useEffect(() => {
    isSubscribed.current = false;
  }, []);

  const onPrintRequest = () => {
    setModalLoading(true);
    postDataWithAuthToken(
      routeId === undefined && orderIds.length === 1
        ? 'order/operate'
        : 'order/batch',
      {
        orderIds: !(routeId === undefined && orderIds.length === 1)
          ? orderIds
          : undefined,
        orderId:
          routeId === undefined && orderIds.length === 1
            ? orderIds[0]
            : undefined,
        operate: 'PRINT',
        remark: mode === 'order' ? '打印订单' : mode === 'invoice' ? "打印Invoice" : mode === 'packingSlip' ? "打印发货单" : undefined,
        isUpdatePrintTime: (!getDashboardStyle().isWholeSaleAppType && mode === 'order') || getDashboardStyle().isWholeSaleAppType,
        routeId: routeId ? routeId : undefined,
      }
    )
      .then((response) => {
        if (response && response.goodStatus) {
          alertMessage('info', t('order.alerts.printing'));
          console.log(
            `Order ID: ${orderIds}, Route ID: ${
              routeId ? routeId : 'N/A'
            }, Time of Print: ${moment().format(DATE_TIME_FORMAT)}`
          );
        } else {
          alertMessage(
            'error',
            response?.msg || t('general.noResponse'),
            response?.data || undefined
          );
        }
        setModalLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setModalLoading(false);
      });
  };

  return (
    <GeneralPrintContent<PrintType>
      mode={mode}
      printoutTableData={
        {
          ordersData: printoutTableData.ordersData,
          userId: userId, // 如果是在User Detail页面，需要传递 userId
          orderIds: orderIds
        } as PrintType
      }
      onCancel={onCancel}
      isFullVersion={isFullVersion}
      beforePrint={
        {
              function: onPrintRequest,
              isLoading: modalLoading,
              setIsLoading: setModalLoading,
        }
      }
    />
  );
};

export default OrderPrintModal;
